/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PermissionsEnumType } from './PermissionsEnum'
import { RootStoreType } from './index'

/**
 * MyPermissionsBase
 * auto generated base class for the model MyPermissionsModel.
 */
export const MyPermissionsModelBase = ModelBase.named('MyPermissions')
  .props({
    __typename: types.optional(types.literal('MyPermissions'), 'MyPermissions'),
    permissions: types.union(types.undefined, types.array(PermissionsEnumType))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class MyPermissionsModelSelector extends QueryBuilder {
  get permissions() {
    return this.__attr('permissions')
  }
}
export function selectFromMyPermissions() {
  return new MyPermissionsModelSelector()
}

export const myPermissionsModelPrimitives = selectFromMyPermissions().permissions
